import React, { forwardRef } from "react";
import { SFStack, SFGridContainer, SFGridItem } from "../grid";
import SFSearchField from "../textField/search";
import SFSelect from "../select";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const ResultsContainer = styled(SFStack)(({ theme }) => ({
  height: "100%",
}));

const SearchInputContainer = styled(SFGridContainer)(({ theme }) => ({
  padding: theme.spacing(5, 2.5, 2.5, 2.5),
}));

const SFSearchFieldStyled = styled(SFSearchField)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.spacing(0.5),
  // Override the default styles for the outline of the input when focused or hovered
  ".MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${theme.palette.grey250.main} !important`,
  },
}));

const SFSelectStyled = styled(SFSelect)(({ theme }) => {
  const borders = {
    borderTop: `0.5px solid ${theme.palette.grey250.main}`,
    borderRight: "none",
    borderBottom: `1px solid ${theme.palette.grey250.main}`,
    borderLeft: `0.5px solid ${theme.palette.grey250.main}`,
    borderRadius: "4px 0px 0px 4px",
  };
  return {
    height: "37px",
    background: theme.palette.grey100.main,
    ".MuiOutlinedInput-notchedOutline": {
      ...borders,
    },
    "&:hover": {
      ".MuiOutlinedInput-notchedOutline": {
        ...borders,
      },
    },
    "&.Mui-focused": {
      ".MuiOutlinedInput-notchedOutline": {
        ...borders,
      },
    },
  };
});

const FullSearchDialogResults = forwardRef(({
  onSearchFieldChange,
  currentSearchText,
  currentSelection,
  renderHeader,
  menuItems,
  onMenuItemSelect,
  initiallySelectedMenuItem,
  children,
}, ref) => {
  const optionFormatter = (value) =>
    menuItems.find((item) => item.value === value)?.label || value;
  return (
    <ResultsContainer>
      <SearchInputContainer spacing={0}>
        {menuItems.length > 0 && (
          <SFGridItem xs={2}>
            <SFSelectStyled
              variant="outlined"
              values={menuItems.map((item) => item.value)}
              selectedValue={initiallySelectedMenuItem}
              onChangeFilter={(option) => onMenuItemSelect(option.value)}
              optionFormatter={optionFormatter}
              valueFormatter={optionFormatter}
            />
          </SFGridItem>
        )}
        <SFGridItem xs>
          <SFSearchFieldStyled
            ref={ref}
            variant="outlined"
            size="small"
            onChange={onSearchFieldChange}
            hasClearBtn
          />
        </SFGridItem>
      </SearchInputContainer>
      {renderHeader &&
        typeof renderHeader === "function" &&
        renderHeader(currentSearchText, currentSelection)}
      {children}
    </ResultsContainer>
  );
});

export default FullSearchDialogResults;
